import React, {Component, useState} from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import LocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import './CalendarField.css';
const { formatDate, parseDate } = LocaleUtils;
const now = new Date();
const currentYear = now.getFullYear();
now.setFullYear(currentYear - 18);

const fromMonth = new Date(currentYear - 50, 0);
const toMonth = new Date(now);

const YearMonthForm = ({ date, localeUtils, onChange }) => {
  const months = localeUtils.getMonths();

  const years = [];
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleChange = (e) => {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select
        name="month"
        onChange={handleChange}
        value={date.getMonth()}
      >
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select
        name="year"
        onChange={handleChange}
        value={date.getFullYear()}
      >
        {years.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </form>
  );
};

const initialStates = {
  selectedDay: new Date(),
  error: false,
  datePicker: false,
  dob: new Date(),
  month: new Date(),
};

const CalendarField = (props) => {
  const [ state, setState ] = useState(initialStates);

  const handleDayClick = (day: Date) => {
    setState({
      ...state,
      selectedDay:  day,
      datePicker: false,
      dob: day,
      month: new Date(),
    });
    props.onSelected(day);
  };

  const handleYearMonthChange = (month) => {
    setState({
      ...state,
      month
    });
  };

    const dayPickerProps = {
      initialMonth: fromMonth,
      disabledDays: {
        before: fromMonth,
        after: toMonth,
      },
      month: state.month,
      fromMonth: fromMonth,
      toMonth: toMonth,
      captionElement: ({ date, localeUtils }) => (
        <YearMonthForm
          date={date}
          localeUtils={localeUtils}
          onChange={handleYearMonthChange}
        />
      ),
    };
    const { error } = state;
    const { label, placeholder, errorMsg, error: showError } = props;
    return (
      <div
        className={`makeFlex column inputFieldContainer calendarField ${
          error ? 'errorField' : ''
        }`}
      >
        <label className={`latoBold appendBottom15 font14 ${showError ? 'redText' : 'defaultGreyText'}`}>
          {label}
        </label>
        <span className="arrow arrow-down-wide" />
        <span className="font12 errorText">{errorMsg}</span>
        <div className="YearNavigation dayPickerHotelWrap dob">
          <DayPickerInput
            showOverlay={false}
            onDayChange={handleDayClick}
            formatDate={formatDate}
            parseDate={parseDate}
            format="LL"
            keepFocus={true}
            placeholder={placeholder}
            dayPickerProps={dayPickerProps}
          />
        </div>
      </div>
    );
  }

  export default CalendarField;
